module.exports = __webpack_public_path__ + "static/media/new_store_sales.6cb37f60.svg";